export default __webpack_public_path__ + "navigation-examples-basic-1200-dfbc5a993515b45a068c491590d07e29.png";